export function buildAgentChatPath(
  workspaceId: string,
  agentSlug: string,
  sessionId?: string | null
): string {
  const basePath = `/${workspaceId}/kb/${agentSlug}/chat`
  return sessionId ? `${basePath}/${sessionId}` : basePath
}

export function isDedicatedAgentChatRoute(
  pathname: string | null | undefined,
  workspaceId: string
): boolean {
  if (!(pathname && workspaceId)) {
    return false
  }

  const segments = pathname.split('/').filter(Boolean)
  if (segments[0] !== workspaceId) {
    return false
  }

  return segments[1] === 'kb' && Boolean(segments[2]) && segments[3] === 'chat'
}

export function isAgentTeachingsRoute(
  pathname: string | null | undefined,
  workspaceId: string
): boolean {
  if (!pathname || !workspaceId) return false

  const segments = pathname.split('/').filter(Boolean)
  if (segments[0] !== workspaceId) return false

  return (
    segments.length === 4 &&
    segments[1] === 'kb' &&
    Boolean(segments[2]) &&
    segments[3] === 'teachings'
  )
}
